import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { GeocodingJob } from './GeocodingBackgrounderRequests';

export type GeocodingConfigsRequestConfigParams = {
  readonly datasourceLuid: string;
}

export type GeocodingConfigRequestConfigParams = {
  readonly configLuid: string;
}


export type deleteGeocodingConfigRequestConfigParams = {
  readonly configId: string;
  readonly datasourceLuid: string;
}

export function getGeocodingConfigsRequestConfig(params: GeocodingConfigsRequestConfigParams): JsonRestApiRequestConfig {
    return {
      restApiVersion: '3.25',
      httpMethod: 'GET',
      endpoint: `datasources/${params.datasourceLuid}/geocodingConfigs`,
      serverWideRequest: false,
    };
  }

export function getGeocodingConfigRequestConfig(params: GeocodingConfigRequestConfigParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.25',
    httpMethod: 'GET',
    endpoint: `geocodingConfigs/${params.configLuid}`,
    serverWideRequest: false,
  };
}

export function addUpdateGeocodingConfigsRequestConfig(datasourceLuid: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.25',
    httpMethod: 'PUT',
    endpoint: `datasources/${datasourceLuid}/geocodingConfigs`,
    serverWideRequest: false,
  };
}

export function deleteGeocodingConfigRequestConfig(params: deleteGeocodingConfigRequestConfigParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.25',
    httpMethod: 'DELETE',
    endpoint: `datasources/${params.datasourceLuid}/geocodingConfigs/${params.configId}`,
    serverWideRequest: false,
  };
}

// raw json response typing from REST API
export type GeocodingConfigResponseObject = {
    id: string;  // config luid
    name: string;
    columnNames: string[];
    tokenLimit: string;   // REST API seems to return this as a string when converted from xml to json
    runGeocodingTask: string;
    lastEstimationJob?: GeocodingJob;
    lastEstimation?: string; // REST API seems to return this as a string when converted from xml to json,
    datasourceId: string;  // datasource luid
};

// Actual typing that is used
// Parsed from GeocodingConfigResponseObject by GeocodingResponseHelper.processGeocodingConfigResponse()
export type GeocodingConfig = {
  id: string;
  name: string;
  columnNames: string[];
  tokenLimit: number;
  runGeocodingTask: string;
  lastEstimationJob?: GeocodingJob;
  lastEstimation?: number;
  datasourceId: string;
};

export type GeocodingConfigResponse = {
  readonly geocodingConfig: GeocodingConfigResponseObject;
};

export type GeocodingConfigsResponse = {
  readonly geocodingConfigs: {
    readonly geocodingConfig: GeocodingConfigResponseObject[];
  };
};

export function callGetConfigsViaApiService(params: GeocodingConfigsRequestConfigParams) {
    return makeJsonRestApiRequest<void, GeocodingConfigsResponse>({
      config: getGeocodingConfigsRequestConfig(params),
      request: null,
    });
}

export function callGetConfigViaApiService(params: GeocodingConfigRequestConfigParams) {
  return makeJsonRestApiRequest<void, GeocodingConfigResponse>({
    config: getGeocodingConfigRequestConfig(params),
    request: null,
  });
}

export type AddUpdateGeocodingConfigRequestBody = {
  readonly geocodingConfigId: string;
  readonly geocodingConfigName: string;
  readonly geocodingColumnNames: string[];
  readonly geocodingTokenLimit: number;
};

export function callAddUpdateConfigViaApiService(datasourceLuid: string, request: AddUpdateGeocodingConfigRequestBody) {
  return makeJsonRestApiRequest<AddUpdateGeocodingConfigRequestBody, GeocodingConfigResponse>({
      config: addUpdateGeocodingConfigsRequestConfig(datasourceLuid),
      request: request,
  });
}

export function callDeleteConfigViaApiService(params: deleteGeocodingConfigRequestConfigParams) {
  return makeJsonRestApiRequest<void, void>({
      config: deleteGeocodingConfigRequestConfig(params),
      request: null,
  });
}
